// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"79571082","787":"2e7998e3"}[chunkId] + ".chunk.js";
};